<template>
	<div class="ipv6-create-container">
		<div class="create-host">
			<div class="jc-page-header">
				<div class="jc-container">
					<el-page-header show-back-icon :title="$t('ipv6.text.openIpv6PublicNetwork')" @back="jumpToUp()" class="relative">
						<template slot="content">
							<div class="jc-list__header--right">
								<a :href="Config.EIP_BUY_URL" target="_blank" class="fr buy-info">
									{{$t('create.text.buyMustKnow')}}
								</a>
							</div>
						</template>
					</el-page-header>
				</div>
			</div>
			<div class="jc-page-content">
				<div class="jc-container pr">
					<div class="buildTab">
						<ul>
							<li class="hover">
								{{ $t('create.text.byConfigurations') }}
							</li>
						</ul>
					</div>
					<div class="buildCon" id="con-tab-1">
						<div class="infoBox">
							<!-- 地域 -->
							<div class="jc-page-card">
								<div class="jc-page-card-header">
									<h3 class="jc-page-card-title">{{$t('create.text.region')}}</h3>
								</div>
								<el-form class="jc-form cps-create-form" label-width="130px">
									<el-form-item :label="$t('create.text.region') | withColon">
										<el-radio-group v-model="selectedRegion">
											<el-radio-button v-for="(regionName,region,index) in regions" :key="index" :label="region">
												{{regionName}}
											</el-radio-button>
										</el-radio-group>
										<el-tooltip effect="dark" class="ml10" placement="right">
										  	<div slot="content" class="my-os-disk-tip">{{$t('create.tooltip.region')}}
										  	</div>
										  	<a><i class="jc-icon-question"></i></a>
										</el-tooltip>
									</el-form-item>
								</el-form>
							</div>
							<!-- 带宽 -->
							<div class="jc-page-card">
								<div class="jc-page-card-header">
									<h3 class="jc-page-card-title">{{$t('create.text.bandwidth')}}</h3>
								</div>
								<!-- 可选IP -->
								<el-form class="jc-form cps-create-form" label-width="130px"
									onsubmit="return false">
									<el-form-item :label="$t('eip.text.selectedIP') | withColon">
										<div class="selectedIpBackground">
											<el-tag
												:key="tag.value"
												v-for="tag in ipv6Tags"
												:closable="true"
												:close-transition="false"
												@close="handleClose(tag)"
												type="gray"
												>
												{{tag.name}}
											</el-tag>
											<span class="ipv6ChooseNumber" v-if="ipv6Tags.length>0">{{'('+ipv6Tags.length+'/10)'}}</span>
										</div>
									</el-form-item>
									<el-form-item :label="$t('eip.text.selectIP') | withColon">
										<el-form class="jc-box-table-search" :inline="true" @submit.native.prevent>	
											<span>{{$t('ipv6.placeholder.search.enableIpv6Address')}}</span>
												<div class="searchIpv6">	
													<el-input 
														class="search-input"
														v-entire-placeholder
														@keyup.enter.native="getPublicIpv6List()"
														:placeholder="currentPlaceholder"
														v-model="currentSearchValue">
														<el-select v-select-auto-width.nomargin
															slot="prepend" id="my-select" v-model="currentSearch"
															@change="changeSearch"
															:placeholder="$t('ipv6.text.gatewayId')" style="width:165px">
															<el-option class="my-select-input" v-for="item in searchSelect"
																:key="item.searchValue"
																:label="item.searchLabel" :value="item.searchValue">
															</el-option>
														</el-select>
														<el-button 
															slot="append" icon="jc-icon-search" class="search-icon"
															@click="getPublicIpv6List()">
														</el-button>
													</el-input>
												</div>
										</el-form>
										<el-table 
											:data="allIpv6InstanceData"
											style="width:100%;position: relative;"
											class="jc-list-table jc-table-header-cell"
											v-loading="refreshLoading"
											ref="listTable"
											:empty-text="$t('speechCraft.listNoText')">
											<!--实例类型-->
											<el-table-column prop="instanceType" 
												:label="$t('eip.text.instanceType')"
												width="80">
												<template slot-scope="scope">
													<span>{{scope.row.instanceType | maybeEmpty}}</span>
												</template>
											</el-table-column>
											<!-- 目标网络接口名称 -->
											<el-table-column prop="targetInternetAccessName" 
												:label="$t('create.text.targetInternetAccessName')"
												width="130">
												<template slot-scope="scope">
													<span>{{transformTargetInternetAccessName(scope.row.interfaceName) | maybeEmpty}}</span>
												</template>
											</el-table-column>
											<!--实例名称-->
											<el-table-column prop="instanceName"
												:label="$t('listPage.text.exampleName')"
												width="80">
												<template slot-scope="scope">
													<span>{{scope.row.instanceName | maybeEmpty}}</span>
												</template>
											</el-table-column>
											<!-- 实例ID -->
											<el-table-column prop="instanceId"
												:label="$t('listPage.text.exampleID')"
												width="180"
												>
												<template slot-scope="scope">
													<span>{{scope.row.instanceId | maybeEmpty}}</span>
												</template>
											</el-table-column>
											<!--所属网络-->
											<el-table-column prop="netBelongTo" 
												:label="$t('subnet.text.netBelongTo')"
												width="80"
												>
												<template slot-scope="scope">
													<span>{{scope.row.vpcName | maybeEmpty}}</span>
												</template>
											</el-table-column>
											<!--IPv6地址-->
											<el-table-column :label="$t('ipv6.text.ipv6Address')" 
												key="ipv6Address"
												min-width="160"
												>
												<template slot-scope="scope">
													<el-select v-model="scope.row.selectedIpv6" 
														:no-data-text="$t('subnet.text.noAvailableIpv6Address')"
														:placeholder="$t('ipv6.placeholder.search.ipv6Address')"
														@visible-change="value=>getIpv6Group(value,scope.row)"
														@change="selectchange(scope.row)"
														:disabled="ipv6Tags.length>9">
														<el-option
														v-for="item in scope.row.ipv6Group"
														:key="item.value"
														:label="item.label"
														:value="item.value">
														</el-option>
													</el-select>
												</template>
											</el-table-column>
										</el-table>
										<p>{{$t('ipv6.text.enableipv6CountTip')}}</p>
									</el-form-item>
									<div id="agreeControlArea">
										<!--带宽计费方式-->
										<el-form-item :label="$t('eip.text.bandwidthCalMode') | withColon">
											<el-radio-group v-model="selectedPaymentType">
												<el-radio-button
													:label="$t('create.placeholder.fixedBandwidth')"></el-radio-button>
											</el-radio-group>
											<el-tooltip  effect="dark" placement="right"
												content="Right Top"
												class="ml10">
												<div slot="content" class="my-os-disk-tip">
													{{$t('ipv6.text.bandwidthCalMode')}}
													<a v-bind:href="Config.Band_Width_BillUrl" target="_blank">
														{{$t('create.tooltip.detail')}}&gt;&gt;
													</a>
												</div>
												<a><i class="jc-icon-question"></i></a>
											</el-tooltip>
										</el-form-item>
										<!--线路-->
										<el-form-item :label="$t('create.text.line') | withColon">
											<el-radio-group v-model="selectedLineType">
												<el-radio-button v-for="(item,key,index) in lineTypes"	    :key="index"
													:label="key">{{item}}
												</el-radio-button>
											</el-radio-group>
											<el-tooltip style="margin-left:10px" effect="dark" placement="right"
												content="Right Top">
												<div slot="content" class="my-os-disk-tip">{{$t('create.tooltip.line',[lineTypes[selectedLineType]])}}
												</div>
												<a><i class="jc-icon-question"></i></a>
											</el-tooltip>
										</el-form-item>
										<!--带宽上限-->
										<el-form-item :label="$t('create.text.bandLimit') | withColon">
											<div class="el-form-item-inline">
												<el-slider v-model="tmpMaxBandwidth" show-input
													@change="calSelectedMaxBandwidth" :max="200" :marks="marks"
													:debounce="0" :min="1" class="jc-slider-custom"></el-slider>
											</div>
										</el-form-item>
									</div>
								</el-form>
							</div>
						</div>
					</div>
					<!-- 已选配置 -->
					<div id="selected" class="jc-form-create-selected">
						<h3 class="selected-title">
							{{$t('create.text.selectedConfig')}}</h3>
						<el-form label-width="75px" class="jc-datashow-list">
							<!--地域-->
							<el-form-item :label="$t('create.text.region')"><p v-if="regions[selectedRegion]">
								{{regions[selectedRegion]}}</p>
								<p v-else>--</p></el-form-item>
							<!--线路-->
							<el-form-item :label="$t('eip.text.line')">
								<p>{{lineTypes[selectedLineType]}}</p>
							</el-form-item>
							<!--带宽-->
							<el-form-item :label="$t('create.text.bandwidth')"
								:title="$t('create.text.bandwidth')">
								{{$t('eip.help.byBandwidth', [selectedMaxBandwidth])}}
							</el-form-item>
							<!--购买数量-->
							<el-form-item :label="$t('ipv6.text.buyNum')"
								:title="$t('ipv6.text.buyNum')">
								{{ipv6Tags.length | maybeEmpty}}
							</el-form-item>
							<section class="selected-cost">
								<h3 class="selected-cost-title">
								{{$t('create.text.cost')}}</h3>
								<!--按配置计费-->
							  	<el-form-item
							  		:label="$t('detail.text.eipv6')">
									<p class="form-item-nopadding" :class="[totalDiscount > 0?'':'form-item-bottom' ]">
									  	<span class="price cff96">
									  	{{ $t('create.text.feePerHour', [discountByConfigurationsTotalPrice])}}</span>
									  	<span class="none">{{configurationCalTotalPrice.discountByConfigurationsTotalPrice}}</span>
									</p>
							  	</el-form-item>
						  		<p class="month-total-price">
									<span>{{ $t('create.text.configureMonthPay', [discountByConfigurationsOneMonthPrice]) }}</span>
								</p>
								<save-price
									v-if="totalDiscount > 0"
									:totalDiscount="favorablePricePerHour"
									:originPrice="totalOriginalPrice"
								></save-price>
							</section>
							<el-button 
								type="primary" size="large"
								:disabled="!isCertification || !ipv6Tags.length"
								class="my-buy-btn"
								@click="buy">{{isBuyTag}}
							</el-button>
							<!--尚未通过实名认证-->
							<p v-if="!isCertification" class="red mt10">
								{{$t('create.help.noCertification')}}
								<a :href="Config.REALNAME_URL">
									{{$t('create.help.goCertificate')}}</a>
							</p>
						</el-form>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>


<script>
import SavePrice from '@/components/common/SavePrice';
import { CreateTypeConstant, NetworkTypeConstant, ServiceCodeConstant, BillingTypesConstant} from '@/common/Constants';
import {changeTwoDecimal,deepCopy,getDifferenceSet, subDecimals, mulDecimals} from '@/common/tool';
import initSelectedPotision from '@/mixins/initSelectedPotision';

export default {
	components: {
		SavePrice
	},
	mixins:[initSelectedPotision],
	data() {
		// 模糊搜索条件设置
		const searchSelect = [
			{
				searchValue: 'idSearch',
				searchLabel: this.$t('listPage.text.exampleID')
			},
			{
				searchValue: 'nameSearch',
				searchLabel: this.$t('listPage.text.exampleName')
			}
		];
		return {
			// 区域
			selectedRegion: '',
			// azName
			selectedAzName: '',
			// 带宽
			currentIpSearchValue: '',
			selectedPaymentType: this.$t('create.placeholder.fixedBandwidth'),
			selectedLineType: 'BGP', // 线路
			tmpMaxBandwidth: 1,
			selectedMaxBandwidth: 1,
			// 实名认证
			isCertification: true,
			isBuyTag: this.$t('create.text.buyNow'),
			// 按配置价格
			totalDiscount: 0, 
			discountByConfigurationsTotalPrice: 0,
			discountByConfigurationsOneMonthPrice: 0,
			totalOriginalPrice: 0,
			// 页面参数选择
			regions: {},
			lineTypes: {},

			scrolled: false,
			// 折扣信息
			discountedInfo: [
				{ message: '' },
				{ message: '' },
				{ message: '' }
			],
			currentSearchValue:'',
			//已选IP tag
			ipv6Tags:[],
			//在过滤已选Ipv6时使用
			ipv6TagsList:[],
			currentSearch: 'nameSearch',
			// 搜索条件下拉选
			searchSelect,
			// 当前搜索条件对应placeholder
			currentPlaceholder: this.$t('ipv6.placeholder.search.nameSearch'),
			refreshLoading: false,
			allIpv6InstanceData: [],
        	multipleChoosedIpv6AddressSelection: [],
			//带宽上限的上限和下限
			marks: {1:'1Mbps',200:'200Mbps'},
      favorablePricePerHour: '', // 省 = 原价 - 应付

		};
	},
	computed: {
		/**
		* 按配置计算
		*/
		configurationCalTotalPrice() {
			return this.configurationsCalculateTotalPrice();
		},
		ServiceCodeConstant: () => ServiceCodeConstant
	},
	watch: {
		selectedRegion(newValue) {
			if (newValue) {
				this.configurationsCalculateTotalPrice();
				this.getLineTypes();
				this.getPublicIpv6List();	
			}
		},
	},
	created() {
		this.ipv6GatewayId = this.$route.query.ipv6GatewayId;
		this.subnetId = this.$route.query.subnetId;
		this.getRegion();	
	},

	methods: {

		getRegion() {
			Ajax.get({
				action: '/getRegions',
				param: {
					networkType: NetworkTypeConstant.IPV6
				},
				success: (data) => {
					for (const i in data.regions) {
						const region = data.regions[i].region;
						const regionName = data.regions[i].regionName;
						this.regions[region] = regionName;
					}
					const passedRegion = this.$route.query.region;
					if (passedRegion !== undefined) {
						this.selectedRegion = passedRegion;
					} else {
						this.selectedRegion = data.regions[0].region;
					}
				}
			});
		},
		
		getLineTypes() {
			const param = {
		        region: this.selectedRegion
		    };
		    Ajax.get('/api/cps/getLineTypes', param)
		    .then((res) => {
	          	const data = res.data.lineTypes;
	          	const lineTypes = {};
	          	for (let i = 0; i < data.length; i++) {
	          		lineTypes[data[i].lineType] = data[i].lineTypeName;
	          		this.lineTypes = lineTypes;
	          	}
	          	this.selectedLineType = Object.keys(this.lineTypes)[0];
		    });
	  	},
		// 按配置计算价格
		configurationsCalculateTotalPrice() {
			if (!this.selectedRegion) {
				return '';
			}
			this.totalDiscount = this.$t('create.text.calculating');
			this.discountByConfigurationsTotalPrice = this.$t('create.text.calculating');
			this.discountByConfigurationsOneMonthPrice = this.$t('create.text.calculating');
			const param = {
				cmd: 1, // 操作类型 1、创建；2、续费；3、升降配；4、删除
				region: this.selectedRegion,
				bw: this.selectedMaxBandwidth,
				count: this.ipv6Tags.length || 1,
				createType: CreateTypeConstant.IPV6,
				billingType: BillingTypesConstant.POSTPAID_BY_DURATION
			};
			Ajax.get('/api/price/calculateTotalPrice',param).then(res => {
        const { discountedTotalPrice, totalDiscount, totalOriginalPrice } = res?.data || {};
				this.totalDiscount = changeTwoDecimal(totalDiscount);
				this.totalOriginalPrice = changeTwoDecimal(totalOriginalPrice);
				this.discountByConfigurationsTotalPrice = changeTwoDecimal(discountedTotalPrice);
				this.discountByConfigurationsOneMonthPrice = changeTwoDecimal(mulDecimals(mulDecimals(discountedTotalPrice, 24), 30));
        this.favorablePricePerHour = totalDiscount ? changeTwoDecimal(subDecimals(totalOriginalPrice, discountedTotalPrice)) : null;
			})
			return '';
		},

		calSelectedMaxBandwidth() {
			this.selectedMaxBandwidth = this.tmpMaxBandwidth;
		},

		jumpToUp() {
			this.$router.push({
				name: 'Ipv6List',
				params: { region: this.selectedRegion }
			});
		},

		buy() {
			const param = {
				orderType: 1, // 订单类型 1、新购；2、续费；3、配置变更
				region: this.selectedRegion, // 区域
				lineType: this.selectedLineType, // 线路
				bw: this.selectedMaxBandwidth, // 带宽
				chargeMode: 1, // 计费类型 1、配置；2、用量；3、包年包月；4、一次性付费
				clientToken: Normal.getClientToken(), // 用于保证请求的幂等性，唯一
				timestamps: Normal.getClientToken(), // 毫秒时间戳
				createType: CreateTypeConstant.IPV6,// 创建类型 basic、vpc、eip
			};
			let multipleChoosedIpv6AddressSelection = deepCopy(this.ipv6Tags);
			if (multipleChoosedIpv6AddressSelection.length) {
				param.ipv6Addresses = multipleChoosedIpv6AddressSelection.map(item => {
					return item.value
				}).join(',')
			}
			Ajax.post('/api/cps/ipv6Addresses/addIpv6AddressesToCar', param)
			.then((res) => {
				const orderId = res.data.tempOrderNumber;
				if(orderId !== '' && orderId !== undefined){
					window.location.href = `${this.Config.ORDER_URL}/confirm?buyId=${orderId}&source=1`;
				}
			})
			.catch(async (err) => {
				const { response } = err.data;
				try {
					const json = await response.json();
					this.$message.error(json.errmsg);
				} catch (ex) {
					console.log(ex);
				}
			});
		},

		getPublicIpv6List(){
			let params = {
        		region: this.selectedRegion,
        		ipv6GatewayId: this.ipv6GatewayId,
        	};
			// 搜索部分添加参数
			if (this.currentSearchValue !== '') {
				switch (this.currentSearch) {
					case 'idSearch': {
						params.instanceId = this.currentSearchValue;
						break;
					}
					case 'nameSearch': {
						params.instanceName = this.currentSearchValue;
						break;
					}
				}
			}
			Ajax.get('/api/cps/listIpv6Instances', params)
			.then((res) => {
				const list = res.data.instances
				list.map((item,index) => {
					item.index = index;
					item.selectedIpv6 = ''; 
					item.ipv6Group = []
				})
				this.allIpv6InstanceData = list;
				
			})
			.catch(async (err) => {
				const { response } = err.data;
				try {
					const json = await response.json();
					this.$message.error(json.errmsg);
				} catch (ex) {
					console.log(ex);
				}
			});
		},

		getIpv6Group(isVisible, row) {
			if (!isVisible) {
				return
			}
			let index = row.index;
			let params = { 
				region:this.selectedRegion,
				ipv6GatewayId: this.ipv6GatewayId,
				instanceId: row.instanceId,
				subnetId:  row.subnetId,
				enableInternet:'no',
				pageNumber:1,
				pageSize:20
			}
			Ajax.get('/api/cps/queryListIpv6Addresses', params)
			.then((res) => {
				let ipv6List = res.data.ipv6Addresses;				
				ipv6List = ipv6List.filter(ipv6item => !this.ipv6TagsList.includes(ipv6item.ipv6Address)).map(item=>{
					const formattedItem = {
						value: item.ipv6Address + '(' + item.type + ')',
						label: item.ipv6Address + '(' + this.transformCharge(item.type)+ ')'
					};
					return formattedItem
				})
				row.ipv6Group = ipv6List
			})
			.catch()
			.finally();
		},

		transformCharge(type) {
			switch (type) {
				case 'rip':
				return this.$t('ipv6.text.rip');
				case 'aliasip':
				return this.$t('ipv6.text.aliasip');
				default:
				return '';
			}
		},

		transformTargetInternetAccessName(type) {
			switch (type) {
				case 'bond':
				return this.$t('create.text.singleInternetAccessChiefName');
				case 'eth0':
				return this.$t('create.text.chiefInternetAccessName');
				case 'eth1':
				return this.$t('create.text.subInternetAccessName');
				default:
				return '';
			}
		},

		// 修改搜索条件
		changeSearch() {
			const searchPlaceholder = this.$t('ipv6.placeholder.search');
			const currentSearchVar = this.currentSearch;
			this.currentPlaceholder = searchPlaceholder[currentSearchVar];
			// 清空当前搜索条件
			this.currentSearchValue = '';
		},

		handleClose(tag) {
			this.ipv6Tags.splice(this.ipv6Tags.indexOf(tag), 1);
			this.ipv6TagsList.splice(this.ipv6TagsList.indexOf(tag), 1);
		},

		changeIpv6Name(val) {
			var n= val.indexOf("(");
			var str= val.substr(0,n);
			var type = this.transformCharge(val.substring(n+1,val.length-1))
			return str + '('+type+')'
		},

		ipv6Str(val) {
			var n= val.indexOf("(");
			var str= val.substr(0,n);
			return str
		},

		selectchange(row) {
			let value = row.selectedIpv6;
			let valueIpv6 = value + '~' + row.instanceId + '~' + row.subnetId
			if(value) {
				const formattedItem = {
						value: valueIpv6,
						name: this.changeIpv6Name(value)
					};
				this.ipv6Tags.push(formattedItem);
				this.ipv6TagsList.push(this.ipv6Str(value))

			}
			this.getIpv6Group(true,row)
			row.selectedIpv6=''
		},
	}
};
</script>

<style lang="scss">
	@import '../../../assets/scss/createCommon';
	@import '../../../assets/scss/selectedConfigure';
	@import '../../../assets/scss/sliderCommon';
	@import 'style';	
</style>



// WEBPACK FOOTER //
// src/views/ipv6/create/Create.vue